import { useEffect, useRef } from 'react';

const contactItems = [
  {
    icon: 'ri-map-pin-2-line',
    label: 'Address',
    value: 'Hrastovec 25B',
  },
  {
    icon: 'ri-building-2-line',
    label: 'City',
    value: 'Zavrc',
  },
  {
    icon: 'ri-mail-send-line',
    label: 'Zip Code',
    value: '2283',
  },
  {
    icon: 'ri-earth-line',
    label: 'Country',
    value: 'Slovenia',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: 'contact@duriddoo.com',
  },
  {
    icon: 'ri-phone-line',
    label: 'Phone',
    value: '+1 5186343719',
  },
];

export default function ContactSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll<HTMLElement>('[data-ci]').forEach((el, i) => {
              setTimeout(() => {
                el.style.opacity = '1';
                el.style.transform = 'translateY(0)';
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" ref={sectionRef} className="py-28 md:py-36 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">

          {/* Left — Intro */}
          <div className="flex-1 max-w-lg">
            <p
              data-ci
              className="text-xs font-semibold tracking-widest uppercase text-emerald-600 mb-5 transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(16px)' }}
            >
              Contact
            </p>
            <h2
              data-ci
              className="text-4xl md:text-5xl font-thin text-gray-900 leading-tight mb-8 transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Get in <strong className="font-semibold">Touch</strong>
            </h2>
            <p
              data-ci
              className="text-base text-gray-500 leading-relaxed transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(16px)' }}
            >
              We are based in Slovenia and available to answer any questions
              you may have about our products or partnership opportunities.
              Reach out to us directly using the contact details below.
            </p>

            {/* Decorative element */}
            <div
              data-ci
              className="mt-14 flex items-center gap-4 transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(16px)' }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-500/10">
                <img
                  src="https://public.readdy.ai/ai/img_res/b284ece8-9fa7-445a-8094-79c7066988ca.png"
                  alt="DURID d.o.o."
                  className="w-8 h-8 object-contain"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">DURID d.o.o.</p>
                <p className="text-xs text-gray-400">iOS App Development</p>
              </div>
            </div>
          </div>

          {/* Right — Contact Info */}
          <div className="flex-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8">
              {contactItems.map((item, idx) => (
                <div
                  key={item.label}
                  data-ci
                  className="flex flex-col gap-1 transition-all duration-700"
                  style={{ opacity: 0, transform: 'translateY(18px)', transitionDelay: `${idx * 60}ms` }}
                >
                  <div className="flex items-center gap-2 mb-1">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${item.icon} text-emerald-500 text-sm`} />
                    </span>
                    <span className="text-xs font-semibold tracking-widest uppercase text-gray-400">
                      {item.label}
                    </span>
                  </div>
                  <p className="text-lg font-semibold text-gray-900 pl-6">{item.value}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
